import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpClient
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EncryptDecryptService } from '../encrypt-decrypt.service';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
        private http: HttpClient,
        private cookieService: CookieService,
        private aRoute: Router,
        private encDecService:EncryptDecryptService
    ) { }

    saveError(data) {
        this.http.post<any>(`${environment.configUrl}Configuration/InsertApplicationErrorLog`, data)
            .subscribe(resData => {
                if (resData.success) {
                    console.log('error saved');
                } else {
                    console.log('failed to save error');
                }
            }, err => {
                console.log('failed to save error');
            });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes('/Configuration/InsertApplicationErrorLog') || request.url.includes('SocketID')|| request.url.includes('/Referral/ViewReferralDocs')) {
            return next.handle(request);
        } else {
            return next.handle(request)
                .pipe(
                    tap((res: HttpResponse<any>) => {
                        if ((res instanceof HttpResponse) && res.body && !res.body.success &&
                            !res.body.results &&
                            !res.body.addresses) {
                            const data = {
                                ApplicationErrorData: JSON.stringify({
                                    ErrorMessage: JSON.stringify(res.body.errorMsg),
                                    ErrorNumber: res.status,
                                    TechnicalErrorMessage: JSON.stringify(res.body.error),
                                    APIName: request.url,
                                    StaffID: 0,
                                    PatientID: this.encDecService.dec(this.cookieService.get("PatientID")),
                                    VersionNumber: environment.version,
                                    IsFromWebsite: 1,
                                    IsFromAdmin: 0,
                                    PageName: this.aRoute.url,
                                })
                            };
                            this.saveError(data);
                            return res;
                        } else {
                            return res;
                        }
                    }), catchError((error: HttpErrorResponse) => {
                        let errorMessage = '';
                        if (error.error instanceof ErrorEvent) {
                            // client-side error
                            errorMessage = error.error.message;
                        } else {
                            // server-side error
                            errorMessage = error.message;
                        }
                        if (errorMessage !== '') {
                            const data = {
                                ApplicationErrorData: JSON.stringify({
                                    ErrorMessage: errorMessage,
                                    ErrorNumber: error.status,
                                    TechnicalErrorMessage: errorMessage,
                                    APIName: request.url,
                                    StaffID: 0,
                                    PatientID: this.encDecService.dec(this.cookieService.get("PatientID")),
                                    VersionNumber: environment.version,
                                    IsFromWebsite: 1,
                                    IsFromAdmin: 0,
                                    PageName: this.aRoute.url,
                                })
                            };
                            this.saveError(data);
                        }
                        return throwError(errorMessage);
                    })
                );
        }
    }
}
